<template>
  <div
    :class="module !== 'pb' ? 'q-px-2x-md q-mt-xxl' : ''"
    class="row text-sm text-neutral"
  >
    <!-- Vendor or Customer -->
    <div class="col-2">
      <span class="text-neutral-80">{{
        source === "purchases" ? "Vendor" : "Customer"
      }}</span>
    </div>
    <div class="col-4">
      <span>
        {{
          source === "purchases"
            ? userDetails.seller?.shop_name
            : userDetails?.po_info?.buyer_name || "-"
        }}
      </span>
      <div>
        <span class="text-xs text-neutral-70">
          {{
            (source === "purchases"
              ? userDetails.seller?.gstin
              : userDetails?.po_info?.buyer_gstin) || "-"
          }}
        </span>
      </div>
    </div>

    <!-- Date -->
    <div class="col-2">
      <span class="text-neutral-80">Date</span>
    </div>
    <div class="col-4">
      <span>{{ formatDate(userDetails?.date, "DD MMM YYYY") }}</span>
    </div>

    <!-- Internal PB No. -->
    <div v-if="module === 'pb'" class="col-2 q-mb-sm">
      <span class="text-neutral-80">Poshn PB No.</span>
    </div>
    <div v-if="module === 'pb'" class="col-4">
      <span>{{ userDetails?.internal_number || "-" }}</span>
    </div>

    <!-- Trade Type -->
    <div v-if="module === 'pb'" class="col-2">
      <span class="text-neutral-80">Trade Type</span>
    </div>
    <div v-if="module === 'pb'" class="col-4">
      <span>{{ userDetails?.trade_type || "-" }}</span>
    </div>

    <!-- Vehicle Number -->
    <div v-if="module === 'cn' || module === 'pb'" class="col-2">
      <span class="text-neutral-80">Vehicle No.</span>
    </div>
    <div v-if="module === 'cn' || module === 'pb'" class="col-4">
      <span>{{ userDetails?.vehicle_number || "-" }}</span>
    </div>

    <!-- Empty slot for dn and pb alignment -->
    <div v-if="module === 'dn' || module === 'pb'" class="col-6"></div>

    <!-- Payment Terms -->
    <div v-if="module === 'cn' || module === 'dn'" class="col-2">
      <span class="text-neutral-80">Payment Terms</span>
    </div>
    <div v-if="module === 'cn' || module === 'dn'" class="col-4">
      <span>
        {{
          ((source === "purchases"
            ? userDetails?.seller?.credit_cycle
            : userDetails?.po_info?.payment_terms) || 0) + " days"
        }}
      </span>
    </div>

    <!-- Bill To -->
    <div class="col-6 q-pt-md">
      <div class="row">
        <div class="col-12">
          <span class="text-neutral-80">Bill To</span>
        </div>
        <div class="col-11 text-sm">
          <span>
            {{ userDetails?.billing_address_info?.shop_name }}<br />
            <template
              v-for="(line, index) in billingAddressLines"
              :key="`bill-${index}`"
            >
              {{ line }}<br v-if="index < billingAddressLines.length - 1" />
            </template>
          </span>
        </div>
      </div>
    </div>

    <!-- Ship To -->
    <div class="col-6 q-pt-md">
      <div class="row">
        <div class="col-12">
          <span class="text-neutral-80">Ship To</span>
        </div>
        <div class="col-11 text-sm">
          <span>
            {{ userDetails?.shipping_address_info?.shop_name }}<br />
            <template
              v-for="(line, index) in shippingAddressLines"
              :key="`ship-${index}`"
            >
              {{ line }}<br v-if="index < shippingAddressLines.length - 1" />
            </template>
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { date } from "quasar";
const { formatDate } = date;

const props = defineProps({
  userDetails: {
    type: Object,
    required: true,
  },
  source: {
    type: String,
    default: "",
  },
  module: {
    type: String,
    default: "",
  },
});

const formatAddressLines = (address) => {
  return typeof address === "string" ? address.split("\n") : [];
};

const billingAddressLines = computed(() =>
  formatAddressLines(unref(props).userDetails?.billing_address),
);

const shippingAddressLines = computed(() =>
  formatAddressLines(unref(props).userDetails?.shipping_address),
);
</script>
